<template>
	<section>
		<precadastro
			:mycolumns="columns"
			:data="data"
			:totalpages="totalPages"
			:is-loading="isLoading"
			:currentpage="currentpage"
			@context-menu-action="tableAction($event)"
			@change-rows-per-page="getDataFilter($event)"
			@filter-apply="getDataFilter($event)"
			@update-table="getDataFilter({ limit: limit, offset: offset })"
			@pagechange="(currentpage = $event.pagenumber), getDataFilter($event)"
			@concluir="finalizarCadastro($event)"
			@multiple-finish="finalizarCadastroMultiple($event)"
			@multiple-aprove="tableMultipleAproveAction($event)"
		/>
	</section>
</template>

<script>
import cookie from 'vue-cookie';
import * as ecAxios from '../../util/ecAxios';
import precadastro from '../../layout/components/table/precadastro';
import global from '../../mixins/global';

export default {
	name: 'ScreenPreCadastro',
	components: {
		precadastro,
	},
	mixins: [global],
	data() {
		return {
			logUser: cookie.get('logUser'),
			currentpage: 1,
			columns: localStorage.getItem('columns')
				? JSON.parse(localStorage.getItem('columns'))
				: [
						{
							label: 'Ações na Linha',
							tooltip: 'Ações',
							field: 'acoes',
							sortable: false,
							display: false,
							normal: false,
							centered: true,
							isacoes: true,
						},
						{
							label: 'Código',
							tooltip: 'id',
							field: 'id',
							sortable: true,
							display: true,
							normal: true,
							centered: true,
						},
						{
							label: 'Seq P.',
							tooltip: 'Seq P.',
							field: 'integracao_id',
							sortable: true,
							display: true,
							normal: true,
							centered: true,
						},
						{
							label: 'Cód Rep.',
							tooltip: 'Cód Rep.',
							field: 'representante',
							sortable: true,
							display: true,
							normal: true,
							centered: true,
						},
						{
							label: 'Situação',
							field: 'situacao',
							sortable: true,
							display: true,
							normal: false,
							centered: true,
							situacao: true,
						},
						{
							label: 'Razão Social',
							tooltip: 'nomerazao',
							field: 'nomerazao',
							sortable: true,
							display: true,
							normal: true,
							centered: false,
						},
						{
							label: 'CNPJ',
							tooltip: 'cnpj',
							field: 'cnpj',
							sortable: true,
							display: true,
							normal: true,
							centered: false,
						},
						{
							label: 'CNAE',
							tooltip: 'cnae',
							field: 'cnae',
							sortable: true,
							display: true,
							normal: true,
							centered: true,
						},
						{
							label: 'Sit. Sintegra / RF',
							field: 'sintegrastatus',
							secondField: 'receitastatus',
							sintegra: true,
							sortable: false,
							display: true,
							normal: false,
							centered: true,
						},
						{
							label: 'UF',
							tooltip: 'uf',
							field: 'uf',
							sortable: true,
							display: true,
							normal: true,
							centered: true,
						},

						{
							label: 'Cidade',
							tooltip: 'cidade',
							field: 'cidade',
							sortable: true,
							display: true,
							normal: true,
							centered: false,
						},

						{
							label: 'Data de Criação',
							field: 'created_at',
							sortable: true,
							display: true,
							normal: false,
							centered: false,
							date: true,
						},

						{
							label: 'Email',
							field: 'email',
							sortable: true,
							display: true,
							normal: true,
							centered: false,
						},
						{
							label: 'Status Solicitação',
							field: 'status',
							sortable: true,
							display: true,
							normal: false,
							centered: true,
							status: true,
						},

						{
							label: 'Motivo Status',
							field: 'motstatusdesc',
							sortable: false,
							display: true,
							normal: true,
							centered: true,
						},
						{
							label: 'Observações',
							field: 'observacao',
							sortable: false,
							display: true,
							normal: true,
							centered: true,
						},
				  ],
			data: [],
			isLoading: true,
			offset: 0,
			limit: 50,
			totalPages: 0,
			situacaoDesc: {
				'-2': 'Análise',
				'-1': 'Digitando',
				0: 'Recebido',
				1: 'Aprovado',
				2: 'Integrado',
				3: 'Integrado',
				4: 'Concluído',
			},
			motstatus: [
				{
					id: 1,
					desc: 'Cidade não atendida',
				},
				{
					id: 2,
					desc: 'Outro',
				},
				{
					id: 3,
					desc: 'Restrições no CNPJ',
				},
			],
		};
	},
	methods: {
		notification(data) {
			this.$buefy.toast.open({
				duration: data.duration,
				message: data.message,
				position: data.postion,
				type: data.type,
			});
		},

		async finalizarCadastroMultiple(datack) {
			const params = {
				situacao: 4,
				created_by: this.logUser,
				id: datack.ids,
			};
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO_UPDATE}`;
				const request = await ecAxios.connection().post(`${url}`, params);
				const { data } = request;
				if (data.error !== 1) {
					this.$buefy.notification.open({
						message: data.message,
						type: 'is-success',
					});
					this.getDataFilter({ limit: this.limit, offset: this.offset });
				} else {
					// eslint-disable-next-line no-throw-literal
					throw { message: data.message };
				}
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message,
					type: 'is-danger',
				});
			}
		},

		async finalizarCadastro(dados) {
			const params = {
				situacao: 4,
				created_by: this.logUser,
				id: dados.selected.id,
			};
			if (!dados.multiple) {
				// eslint-disable-next-line no-alert
				const confirm = window.confirm('Confirma finalização do cadastro?');
				if (!confirm) return;
			}
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO_UPDATE}`;
				const request = await ecAxios.connection().post(`${url}`, params);
				const { data } = request;
				if (data.error !== 1) {
					this.$buefy.notification.open({
						message: data.message,
						type: 'is-sucess',
					});
					this.getDataFilter({ limit: this.limit, offset: this.offset });
				} else {
					// eslint-disable-next-line no-throw-literal
					throw { message: data.message };
				}
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message,
					type: 'is-danger',
				});
			}
		},
		async getDataFilter(paginationData) {
			const event = JSON.parse(localStorage.getItem('filters-precadastro'));
			this.isLoading = true;
			this.offset = paginationData.offset;
			this.limit = paginationData.limit;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTROS}`, {
					cidade: event.cidadeData,
					dateRange: event.dateRange,
					sintegrastatus: event.sintegrastatus,
					situacao: event.situacao,
					status: event.status,
					motstatus: event.motStatusData,
					uf: event.estadosData,
					direction: event.direction ? event.direction : 'desc',
					limit: paginationData.limit,
					offset: paginationData.offset,
					orderby: event.orderby ? event.orderby : 'created_at',
					searchTerm: event.searchTerm,
				})
				.then((response) => {
					if (response.data.error === 0) {
						this.isLoading = false;
						this.data = response.data.usuarioCadastros;
						this.totalPages = response.data.count;
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
		},

		async tableMultipleAproveAction(ids) {
			this.isLoading = true;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO_UPDATE}`;
				const params = {
					situacao: 1,
					created_by: this.logUser,
					id: ids,
				};
				const request = await ecAxios.connection().post(`${url}`, params);
				const { data } = request;
				if (data) {
					this.getDataFilter({ limit: this.limit, offset: this.offset });
					this.notification({
						duration: 5000,
						message: 'Cadastro aprovado com sucesso!',
						position: 'is-bottom',
						type: 'is-success',
					});
					this.isLoading = false;
				} else {
					// eslint-disable-next-line no-throw-literal
					throw { message: data.message };
				}
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message || 'Ops! Ocorreu um erro ao aprovar o cadastro',
					type: 'is-danger',
				});
			}
		},

		async tableAction(action) {
			this.isLoading = true;
			if (action.action === 1) {
				try {
					const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO_UPDATE}`;

					const params = {
						situacao: 1,
						created_by: this.logUser,
						id: [action.selected.id],
					};
					const request = await ecAxios.connection().post(`${url}`, params);
					const { data } = request;
					if (data) {
						this.getDataFilter({ limit: this.limit, offset: this.offset });
						this.notification({
							duration: 5000,
							message: 'Cadastro aprovado com sucesso!',
							position: 'is-bottom',
							type: 'is-success',
						});
						this.isLoading = false;
					} else {
						// eslint-disable-next-line no-throw-literal
						throw { message: data.message };
					}
				} catch (e) {
					this.$buefy.notification.open({
						message: e.message || 'Ops! Ocorreu um erro ao aprovar o cadastro',
						type: 'is-danger',
					});
				}
			}
			if (action.motivo) {
				this.isLoading = true;
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO_ARQUIVAR}`, {
						motivo: action.motivo,
						id: action.id,
					})
					.then((response) => {
						if (response.status === 200) {
							this.getDataFilter({ limit: this.limit, offset: this.offset });
							this.notification({
								duration: 5000,
								message: 'Cadastro arquivado com sucesso!',
								position: 'is-bottom',
								type: 'is-success',
							});
							this.isLoading = false;
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			}
			if (action.unarchive) {
				this.isLoading = true;
				await ecAxios
					.connection()
					.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO_DESARQUIVAR}`, {
						id: action.id,
					})
					.then((response) => {
						if (response.data) {
							this.getDataFilter({ limit: this.limit, offset: this.offset });
							this.notification({
								duration: 5000,
								message: 'Cadastro desarquivado com sucesso!',
								position: 'is-bottom',
								type: 'is-success',
							});
							this.isLoading = false;
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			}
		},
	},
};
</script>

<style scoped lan="scss">
.container-pay-creditcard {
	padding: 10px 10px 20px 10px;
	background-color: #fff;
}
</style>

